<template>
  <div class="overlay">
    <div class="centered-element">
      <h6>Loading actual data is still in progress...</h6>
      <div class="loading-spinner"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
}
</script>

<style scoped>
body, html {
  height: 100%; /* Ensure full height for body and html */
  margin: 0; /* Remove default margins */
}

.overlay {
  position: fixed; /* Use fixed positioning to cover the viewport */
  bottom: 0; /* Align to the top of the page */
  left: 0; /* Start from the left edge */
  width: 100%; /* Full width */
  z-index: 1000; /* High z-index to appear above other content */
  background: rgba(0, 0, 0, 0.5); /* Optional: semi-transparent background */
  display: flex; /* Use flexbox for centering */
  justify-content: center; /* Center horizontally */
  align-items: center; /* Align items to the top */
  padding-top: 10px; /* Add some padding from the top */
}

.centered-element {
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Align items to the top */
  color: var(--text-primary); /* Text color */
  text-align: center; /* Center text and spinner inside */
  padding: 10px 20px; /* Padding for spacing */
  border-radius: 5px; /* Optional: rounded corners */
  background: var(--card-bg);
  box-shadow: 0 2px 10px var(--shadow-color);
}

.loading-spinner {
  margin-left: 1%;
  width: 50px;
  height: 50px;
  border: 5px solid var(--bg-tertiary);
  border-top: 5px solid #07f843;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
